/** @format */

"use client";
import CustomButton from "@/component/Buttons/CustomButton";
import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { apiService } from "@/services/api.services";
import { useRouter } from "next/navigation";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const FooterContactForm = () => {
  const router = useRouter();
  const [submissionSuccessful, setSubmissionSuccessful] = useState(false);

  const validationSchema = Yup.object().shape({
    name_footer: Yup.string().required("Name is required"),
    email_footer: Yup.string()
      .email("Please enter a valid email")
      .required("Email is required"),
    phoneNumber_footer: Yup.string()
      .required("Phone Number is required")
      .min(12, "Please enter a valid phone number"),
    message_footer: Yup.string().required("Message is required"),
  });

  const formik = useFormik({
    initialValues: {
      name_footer: "",
      email_footer: "",
      phoneNumber_footer: "",
      message_footer: "",
    },

    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      console.log("Form Values Before Submission:", values);

      let payload = {
        data: {
          first_name: values.name_footer,
          message: values.message_footer,
          email: values.email_footer,
          phone_number: values.phoneNumber_footer,
        },
      };

      console.log("Submitting payload:", payload);
      try {
        const response = await apiService.postContactUsDetailsFooter(payload);
        if (response.status === 200 || response.status === 201) {
          await apiService.sendThankyouMail({ data: payload.data });
          setSubmissionSuccessful(true);
          setTimeout(() => {
            router.push("/thankyou");
          }, 900);
          resetForm();
        } else {
          setSubmissionSuccessful(false);
        }
      } catch (error) {
        console.log(error);
        setSubmissionSuccessful(false);
      }
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} className="contactform_container">
      <div className="contactform">
        <TextInput
          placeholder="Name"
          id="name_footer"
          name="name_footer"
          value={formik.values.name_footer}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          errorText={formik.touched.name_footer && formik.errors.name_footer}
        />
      </div>

      <div className="contactform">
        <TextInput
          placeholder="Email"
          id="email_footer"
          name="email_footer"
          value={formik.values.email_footer}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          errorText={formik.touched.email_footer && formik.errors.email_footer}
        />
      </div>

      <div className="contactform">
        <div className="custom_number_container">
          <PhoneInput
            country={"us"}
            name="phoneNumber_footer"
            id="phoneNumber_footer"
            inputProps={{
              name: "phoneNumber_footer",
              id: "phoneNumber_footer",
            }}
            copyNumbersOnly
            enableSearch
            value={formik.values.phoneNumber_footer}
            onChange={(value) => {
              formik.setFieldValue("phoneNumber_footer", value);
            }}
          />
          {formik.touched.phoneNumber_footer && formik.errors.phoneNumber_footer && (
            <p className="error-message">{formik.errors.phoneNumber_footer}</p>
          )}
        </div>
      </div>

      <div className="contactform">
        <TextInput
          placeholder="Message"
          id="message_footer"
          name="message_footer"
          value={formik.values.message_footer}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          errorText={formik.touched.message_footer && formik.errors.message_footer}
          multi={true}
        />
      </div>

      <div className="contactform_container_row contactform_container_row_bottom">
        <div>
          <CustomButton
            isLoading={formik.isSubmitting}
            Text={
              !formik.isSubmitting && formik.isValid && submissionSuccessful
                ? "Submitted"
                : "Submit"
            }
            type="submit"
          />
        </div>
      </div>
    </form>
  );
};

const TextInput = ({
  errorText,
  label,
  placeholder,
  value,
  onChange,
  multi,
  ...props
}) => {
  if (multi) {
    return (
      <div className="input-container">
        <label htmlFor="input-field">{label}</label>
        <textarea
          {...props}
          id="input-field"
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          cols="30"
          rows="5"
        />
        {errorText && <p className="error-message">{errorText}</p>}
      </div>
    );
  }
  return (
    <div className="input-container">
      <label htmlFor="input-field">{label}</label>
      <input
        {...props}
        type="text"
        id="input-field"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      {errorText && <p className="error-message">{errorText}</p>}
    </div>
  );
};

export default FooterContactForm;
